import $ from 'jquery' // jQuery
import './module/_hashScroll' // アンカーリンクスクロール
import './module/_spMenuToggle' // SPメニュー開閉

/* global  */ // tUrl等のグローバル変数を宣言する

import './_top.js'
import './_form.js'
import './_poptoast.js'
import './_message.js'
import './_errorLog.js'
import ScrollHint from 'scroll-hint'
import scrollLock from './functions/_scrollLock.js' // スクロールロック

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

/*
##     ##  #######  ########     ###    ##
###   ### ##     ## ##     ##   ## ##   ##
#### #### ##     ## ##     ##  ##   ##  ##
## ### ## ##     ## ##     ## ##     ## ##
##     ## ##     ## ##     ## ######### ##
##     ## ##     ## ##     ## ##     ## ##
##     ##  #######  ########  ##     ## ########
*/
const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体

if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal--open')) {
      return
    }
    const target = e.target.closest('.js-modal--open').dataset.modal
    e.preventDefault()
    if (
      target !== 'mail-send' &&
      target !== 'mail-cancel' &&
      target !== 'mail-cancelResponse' &&
      target !== 'mail-selectCancel' &&
      target !== 'mail-userClear'
    ) {
      modalClose()
    }
    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }
    modalOverlay.classList.add('active')
    scrollLock('body', '#modalOverlay')
  })

  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}

/*
########  #######   ######    ######   ##       ########
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##    ##     ## ##        ##        ##       ##
   ##    ##     ## ##   #### ##   #### ##       ######
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##    ##     ## ##    ##  ##    ##  ##       ##
   ##     #######   ######    ######   ######## ########
*/
if (document.getElementsByClassName('js-toggleView')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-toggleView')) {
      return
    }
    const group = e.target.dataset.toggleGroup
    const target = e.target.dataset.toggleTarget
    toggleView(group, target)
  })
}
function toggleView(group, target) {
  const hide = document.getElementsByClassName('js-toggleView-group--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.remove('active')
  }
  const view = document.getElementsByClassName('js-toggleView-target--' + target)
  for (let index = 0; index < view.length; index++) {
    view[index].classList.add('active')
  }
}

//
//  #####    ###     #####
//  ##      ## ##   ##   ##
//  #####  ##   ##  ##   ##
//  ##     #######   #####
//  ##     ##   ##  ##
//

$('.js-faq-ques').click(function () {
  $(this).toggleClass('open')
  $(this).next('.js-faq-ans').slideToggle()
})

/*
######     ####      #####  ##    ##  ########   #####    ######
##   ##  ##    ##  ##       ##  ##       ##    ##     ##  ##   ##
######   ########  ##       ####         ##    ##     ##  #####
##   ##  ##    ##  ##       ##   ##      ##    ##     ##  ##
######   ##    ##   ######  ##     ##    ##      #####    ##
*/
var back2top = $('#back2top')
back2top.on('click', function (e) {
  e.preventDefault()
  $('html, body').animate({ scrollTop: 0 }, '300')
})

/*
  #####  ##    ##  ######   #####  ##   ##      ####    ##      ##
##       ##    ##  ##     ##       ##  ##     ##    ##  ##      ##
##       ########  #####  ##       ####       ########  ##      ##
##       ##    ##  ##     ##       ##  ##     ##    ##  ##      ##
  #####  ##    ##  ######   #####  ##    ##   ##    ##  ######  ######
*/
$('.chk_all').on('click', function () {
  let items = $(this).closest('.listTree').find("input[class != 'chk_all']")
  if (this.checked) {
    items.each(function () {
      this.checked = true
    })
  } else {
    items.each(function () {
      this.checked = false
    })
  }
})

$("input[type=checkbox][class !='chk_all']").on('click', function () {
  let parent = $(this).closest('.listTree').find("input[class !='chk_all']")

  if ($(parent).filter(':checked').length == $(parent).length) {
    $(this).closest('.listTree').find("input[class ='chk_all']").prop('checked', true)
  } else {
    $(this).closest('.listTree').find("input[class ='chk_all']").prop('checked', false)
  }
})

/*
 ######  ##     ## ########  ######  ##    ##
##    ## ##     ## ##       ##    ## ##   ##
##       ##     ## ##       ##       ##  ##
##       ######### ######   ##       #####
##       ##     ## ##       ##       ##  ##
##    ## ##     ## ##       ##    ## ##   ##
 ######  ##     ## ########  ######  ##    ##
*/
/*
           ###    ##       ##
          ## ##   ##       ##
         ##   ##  ##       ##
####### ##     ## ##       ##
        ######### ##       ##
        ##     ## ##       ##
        ##     ## ######## ########
*/
// 同一グループすべてを切り替えるチェック
if (document.getElementsByClassName('js-allCheck')[0]) {
  // 親の切り替えを子に反映する
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-allCheck')) {
      return
    }
    allCheck(e.target)
  })
  // 子の状態を親に反映する
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-allCheck-child')) {
      return
    }
    allCheckChild(e.target)
  })
}

/*
         ######  ##    ## ##    ##  ######
        ##    ##  ##  ##  ###   ## ##    ##
        ##         ####   ####  ## ##
#######  ######     ##    ## ## ## ##
              ##    ##    ##  #### ##
        ##    ##    ##    ##   ### ##    ##
         ######     ##    ##    ##  ######
*/
// 同じチェックボックスを同期させる
if (document.getElementsByClassName('js-checkSync')[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-checkSync')) {
      return
    }
    const group = e.target.dataset.group // グループ取得
    allCheckChild(e.target)

    checkTrace(group)
  })
}

function allCheck(item) {
  const checked = item.checked // 親のチェック状態取得
  const group = item.dataset.allCheck // グループ取得
  const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
  // 親のチェック状態を子に伝播させ
  for (let index = 0; index < checkList.length; index++) {
    checkList[index].checked = checked
  }
  checkTrace(group)
}

function allCheckChild(item) {
  const group = item.dataset.allCheck // グループ取得
  const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
  const checkListChecked = document.querySelectorAll('.js-allCheck--' + group + ':checked') // チェック済みの子
  const checkCurrent = document.querySelectorAll('.js-allCheck[data-all-check="' + group + '"]') // 親チェック

  // すべての子チェックがチェック済みかどうかで親チェックを切り替え
  for (let index = 0; index < checkCurrent.length; index++) {
    if (checkList.length === checkListChecked.length) {
      checkCurrent[index].checked = true
    } else {
      checkCurrent[index].checked = false
    }
  }

  checkTrace(group)
}

function checkTrace(group) {
  // チェック内容を各所に反映する
  let nameData = ''
  let valData = ''

  const checkListChecked = document.querySelectorAll('.js-checkTrace[data-group="' + group + '"]:checked')

  let skipTarget = ''
  for (let index = 0; index < checkListChecked.length; index++) {
    const element = checkListChecked[index]

    if (element.classList.contains('js-allCheck')) {
      skipTarget = element.dataset.allCheck // 全体チェックは以降スキップする
    }
    if (element.classList.contains('js-allCheck--' + skipTarget)) {
      continue
    }

    if (nameData !== '') {
      nameData += ','
    }
    nameData += element.dataset.name
    if (valData !== '') {
      valData += ','
    }
    valData += element.value
  }

  if (nameData === '') {
    nameData = '指定なし'
  }

  const textTarget = document.getElementsByClassName('js-checkTrace--' + group)
  for (let index = 0; index < textTarget.length; index++) {
    textTarget[index].innerHTML = nameData
  }
  const hideTarget = document.getElementsByClassName('js-checkTrace-hide--' + group)
  for (let index = 0; index < hideTarget.length; index++) {
    hideTarget[index].classList.add('active')
  }
  const valueTarget = document.getElementsByClassName('js-checkTrace-hidden--' + group)
  for (let index = 0; index < valueTarget.length; index++) {
    valueTarget[index].value = valData
  }

  preCount()
}

/*
 ######   #######  ##     ## ##    ## ########
##    ## ##     ## ##     ## ###   ##    ##
##       ##     ## ##     ## ####  ##    ##
##       ##     ## ##     ## ## ## ##    ##
##       ##     ## ##     ## ##  ####    ##
##    ## ##     ## ##     ## ##   ###    ##
 ######   #######   #######  ##    ##    ##
*/
function preCount() {
  const formList = document.getElementsByClassName('js-preCount')
  for (let index = 0; index < formList.length; index++) {
    const element = formList[index]
    const group = element.dataset.pre
    const valueList = element.getElementsByClassName('js-preCount-item')
    let ajaxParam = hUrl + 'job/?count=1'
    for (let index = 0; index < valueList.length; index++) {
      const item = valueList[index]
      ajaxParam += '&' + item.name + '=' + item.value
    }
    preCountAjax(group, ajaxParam)
  }
}

let lastQuery = []
let countAjax = []
function preCountAjax(group, ajaxParam) {
  if (lastQuery[group] === ajaxParam) {
    // 直前に送ったクエリと同じなら中止
    return
  }

  lastQuery[group] = ajaxParam
  const viewList = document.getElementsByClassName('js-preCount--' + group)

  for (let index = 0; index < viewList.length; index++) {
    const element = viewList[index]
    element.innerHTML = '...'
  }
  if (countAjax[group]) {
    // 同じAjaxを実行中の場合は打ち切る
    countAjax[group].abort()
    countAjax[group] = null
  }
  countAjax[group] = new XMLHttpRequest() // Ajaxリクエスト
  countAjax[group].open('GET', ajaxParam, true) // GET/POST, URL, 非同期処理
  countAjax[group].setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxアクセスを明示するリクエストヘッダー
  countAjax[group].responseType = 'text' // 取得タイプ document text json
  countAjax[group].timeout = 5000 // タイムアウト判定時間
  countAjax[group].send() // リクエスト実行
  // ajax.send(ajaxParam) // POSTリクエスト実行
  countAjax[group].onload = function () {
    // 受信成功
    if (countAjax[group].status < 200 || countAjax[group].status >= 400) {
      console.log('Error: Code ' + countAjax[group].status) // エラー
      return
    }

    for (let index = 0; index < viewList.length; index++) {
      const element = viewList[index]
      element.innerHTML = this.response
    }
  }
  countAjax[group].ontimeout = function (e) {
    // タイムアウト
  }
  countAjax[group].onerror = function () {
    // 受信失敗（Cross-Origin制約や回線不良など）
  }
  countAjax[group].onprogress = function (e) {
    // リクエスト中に反復実行
  }
  countAjax[group].onabort = function () {
    // abort()により中断
  }
  countAjax[group].onloadend = function () {
    // 受信成否に関わらず実行
  }
}

// リンクをコピー
var PageUrl = window.location.href
$('.js-copy-url').on('click', function () {
  // フラッシュメッセージ表示
  $('.btnShare--msg').fadeIn('slow', function () {
    navigator.clipboard.writeText(PageUrl)

    $(this).delay(2000).fadeOut('slow')
  })
})

/*
   ###          ##    ###    ##     ##
  ## ##         ##   ## ##    ##   ##
 ##   ##        ##  ##   ##    ## ##
##     ##       ## ##     ##    ###
######### ##    ## #########   ## ##
##     ## ##    ## ##     ##  ##   ##
##     ##  ######  ##     ## ##     ##
*/
let ajax = false // Ajaxリクエスト

/*
        ##       #### ##    ## ##    ##
        ##        ##  ###   ## ##   ##
        ##        ##  ####  ## ##  ##
####### ##        ##  ## ## ## #####
        ##        ##  ##  #### ##  ##
        ##        ##  ##   ### ##   ##
        ######## #### ##    ## ##    ##
*/

if (document.getElementsByClassName('js-linkAjax')[0]) {
  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-linkAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.attributes['href'].value // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      const flag = item.dataset.flag // 追加の処理フラグ
      applyAjax(url, from, to, pushSt, type, scroll, flag)
    }
  })
}

/*
        #### ##    ## ########  ##     ## ########
         ##  ####  ## ##     ## ##     ##    ##
#######  ##  ## ## ## ########  ##     ##    ##
         ##  ##  #### ##        ##     ##    ##
        #### ##    ## ##         #######     ##

テキスト入力時に通信する
<input id="" class="js-textAjax" type="text" name="" placeholder="" data-url="<?php echo H_URL; ?>" data-from="#a" data-to="#a" data-push="on">
*/
let ajaxWord = ''
if (document.getElementsByClassName('js-textAjax')) {
  window.addEventListener('input', (e) => {
    if (e.target.classList.contains('js-textAjax')) {
      e.preventDefault()
      const item = e.target
      if (item.classList.contains('reset')) {
        item.classList.remove('reset')
      } else if (ajaxWord === item.value) {
        // キーワードが変わっていなければ処理しない
        return false
      }
      ajaxWord = item.value
      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, from, to, pushSt, type, scroll)
    }
  })
}

/*
         ######  ######## ##       ########  ######  ########
        ##       ##       ##       ##       ##          ##
#######  ######  ######   ##       ######   ##          ##
              ## ##       ##       ##       ##          ##
         ######  ######## ######## ########  ######     ##

セレクトボックスの切替時、valueのURLに通信する
<select name="" class="js-selectAjax" data-from="#a" data-to="#a" data-push="on">
    <option value="https://example.com">最新順</option>
</select>
*/
if (document.getElementsByClassName('js-selectAjax')) {
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-selectAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.value // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, from, to, pushSt, type, scroll)
    }
  })
}

/*
        ##        #######     ###    ########
        ##       ##     ##  ##   ##  ##     ##
####### ##       ##     ## ##     ## ##     ##
        ##       ##     ## ######### ##     ##
        ########  #######  ##     ## ########

ページアクセス時にロードする
<div id="js-loadAjax" data-url="" data-from="" data-to=""></div>
*/
const loadAjax = document.getElementById('js-loadAjax')
if (loadAjax) {
  const item = loadAjax
  const url = item.dataset.url // 取得先
  const from = item.dataset.from // 取得要素
  const to = item.dataset.to // 差し替え要素
  applyAjax(url, from, to, false, 'rep', false)
}

/*
        ########     ###     ######  ##    ##
        ##     ##  ##   ##  ##       ##  ##
####### ########  ##     ## ##       #####
        ##     ## ######### ##       ##  ##
        ########  ##     ##  ######  ##    ##

ブラウザバックでのアクセス時にURL通りのものをロードする
<div id="js-backAjax" data-from="#a" data-to="#a"></div>
*/
const backAjax = document.getElementById('js-backAjax')
if (backAjax) {
  if (window.history && window.history.pushState) {
    window.onpopstate = function (e) {
      const item = backAjax
      const url = location.href // 取得先
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      applyAjax(url, from, to, false, 'rep', false)
    }
  }
}

/*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
/**
 * Ajax処理を実行する
 * @param url {string} 取得先のURL
 * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
 * @param to {string} 取得先のセレクタ　,区切りで複数指定
 * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
 * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
 * @param scroll {string} 指定の位置にスクロールさせる
 * @param flag {string} 独自の拡張用
 */
function applyAjax(url, from, to, pushSt, type = 'rep', scroll = false, flag = null, loading = true) {
  from = from.split(',') // ,区切りで配列に変換
  to = to.split(',') // ,区切りで配列に変換

  if (pushSt === 'on') {
    history.pushState(null, null, url) // URL変更
  }

  // Ajaxと明示するパラメータを付ける
  if (~url.indexOf('?')) {
    url += '&ajax=1'
  } else {
    url += '?ajax=1'
  }

  const loadingItem = document.createElement('div')
  loadingItem.className = 'md-loading active'

  // ローディング処理
  if (loading) {
    for (let index = 0; index < to.length; index++) {
      const itemTo = document.querySelector(to[index])
      const loadingItem = document.createElement('div')
      loadingItem.className = 'md-loading active'
      if (type === 'rep') {
        loadingItem.style.width = itemTo.offsetWidth + 'px'
        loadingItem.style.height = itemTo.offsetHeight + 'px'
        itemTo.innerHTML = ''
      }
      itemTo.appendChild(loadingItem)
    }
  }

  if (ajax) {
    // 既に通信中なら切断
    ajax.abort()
  }

  ajax = new XMLHttpRequest() // Ajaxリクエスト
  ajax.open('GET', url, true) // GET/POST, URL, 非同期処理
  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  ajax.setRequestHeader('Pragma', 'no-cache')
  ajax.setRequestHeader('Cache-Control', 'no-cache')
  ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  ajax.responseType = 'document' // 取得タイプ
  ajax.timeout = 10000 // タイムアウト判定時間
  ajax.send() // リクエスト実行
  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }

    for (let index = 0; index < to.length; index++) {
      const itemFrom = this.response.querySelector(from[index])
      const itemTo = document.querySelector(to[index])

      if (type === 'rep') {
        itemTo.innerHTML = itemFrom.innerHTML
      } else {
        // addなら既存の要素を消さずに追加
        const delLoading = itemTo.querySelector('.md-loading')
        delLoading.parentNode.removeChild(delLoading)
        itemTo.innerHTML += itemFrom.innerHTML
      }
      if (scroll) {
        if (document.getElementById('header')) {
          autoScroll(scroll, '#header', true)
        } else {
          autoScroll(scroll, 0, true)
        }
      }
    }
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
    ajax = false
  }
}

/*
########     ###     ######   ######  ##      ##  #######  ########  ########
##     ##   ## ##   ##    ## ##    ## ##  ##  ## ##     ## ##     ## ##     ##
##     ##  ##   ##  ##       ##       ##  ##  ## ##     ## ##     ## ##     ##
########  ##     ##  ######   ######  ##  ##  ## ##     ## ########  ##     ##
##        #########       ##       ## ##  ##  ## ##     ## ##   ##   ##     ##
##        ##     ## ##    ## ##    ## ##  ##  ## ##     ## ##    ##  ##     ##
##        ##     ##  ######   ######   ###  ###   #######  ##     ## ########
*/
/*
チェックボックスでパスワードの表示非表示を切り替え
<input type="password" name="password" class="js-passToggle-target--login" placeholder="">
<input type="checkbox" name="password-view" class="js-passToggle" value="パスワードを表示する" data-pass="login">
*/
if (document.getElementsByClassName('js-passToggle')[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-passToggle')) {
      return
    }
    const target = e.target.dataset.pass // ターゲット取得
    if (e.target.checked) {
      document.getElementsByClassName('js-passToggle-target--' + target)[0].type = 'text'
    } else {
      document.getElementsByClassName('js-passToggle-target--' + target)[0].type = 'password'
    }
  })
}

/*
#######   ####    ##     ##    #####    #######    ##  ########  #######
##      ##    ##  ##     ##  ##     ##  ##    ##   ##     ##     ##
######  ########  ##     ##  ##     ##  ######     ##     ##     ######
##      ##    ##   ##   ##   ##     ##  ##    ##   ##     ##     ##
##      ##    ##     ###       #####    ##     ##  ##     ##     #######
*/
/*
  ######   #####    ##     ##  ###        ##  ########
##       ##     ##  ##     ##  ##  ##     ##     ##
##       ##     ##  ##     ##  ##    ##   ##     ##
##       ##     ##  ##     ##  ##      ## ##     ##
  ######   #####      #####    ##        ###     ##
*/
/**
 * favorites-updated-single
 * Fires after a favorite button has been submitted successfully
 * @param favorites - Array of post objects the user has favorited
 * @param post_id - The post ID that was updated
 * @param site_id - The site ID for the post that was updated (for multisite)
 * @param status - Whether the button was active or inactive
 */
jQuery(function ($) {
  $(document).on('favorites-updated-single', function (event, favorites, post_id, site_id, status) {
    let obj = favorites[0]['posts']
    let fav_total = Object.keys(obj).length
    $('.js_fav_count').text(fav_total)
    $('.js_fav_count').attr('data-count', fav_total)
  })
})

/*
  #####  ##    ##  ######   ######   ######  ###       ##  #######
##       ##    ##  ##   ##  ##   ##  ##      ## ##     ##    ##
##       ##    ##  #####    #####    #####   ##   ##   ##    ##
##       ##    ##  ##   ##  ##  ##   ##      ##     ## ##    ##
 ######    ####    ##    ## ##    ## ######  ##       ###    ##
*/
if (document.getElementsByClassName('js-sidebar-link')[0]) {
  const mybarLink = document.querySelectorAll('.js-sidebar-link')
  let currentLink = location.href.split('?')[0] // パラメータを除く
  mybarLink.forEach((targetLink) => {
    if (targetLink.href === currentLink) targetLink.classList.add('curr')
  })
}

/*
  #####   ######    ######
##        ##    ## ##
##   ###  ######    ######
##    ##  ##             ##
  #####   ##       #######
*/
if (document.getElementById('gps_map')) {
  const getLocationButton = document.getElementById('gps_map')
  getLocationButton.addEventListener('click', (e) => {
    e.preventDefault()
    if (navigator.geolocation) {
      // 現在位置を取得する
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // 緯度
          var lat = position.coords.latitude
          // 軽度
          var lo = position.coords.longitude

          var base_link = document.getElementById('gps_map').getAttribute('href')
          var url = base_link + '?la=' + lat + '&lo=' + lo
          //  location.href = url;
          window.open(url, '_top')
        },
        (error) => {
          var err_msg = ''
          switch (error.code) {
            case 1:
              err_msg = '位置情報の利用が許可されていません'
              break
            case 2:
              err_msg = '位置情報が取得できませんでした'
              break
            case 3:
              err_msg = '位置情報が取得できませんでした'
              break
          }
          alert(err_msg)
        }
      )
    } else {
      alert('ブラウザは位置情報に対応していません。')
    }
  })
}

//   ####  #####  ##      #####   ####  ######                ##  ##   ##  ###    ###  #####
//  ##     ##     ##      ##     ##       ##                  ##  ##   ##  ## #  # ##  ##  ##
//   ###   #####  ##      #####  ##       ##    ########      ##  ##   ##  ##  ##  ##  #####
//     ##  ##     ##      ##     ##       ##              ##  ##  ##   ##  ##      ##  ##
//  ####   #####  ######  #####   ####    ##               ####    #####   ##      ##  ##
/*
<select name="" class="js-selectJump">
    <option value="" data-link=""></option>
</select>
*/

window.addEventListener('change', function (e) {
  const item = e.target.closest('.js-selectJump')
  if (!item) {
    return
  }
  const link = item.querySelector('option:checked').dataset.link
  if (link) {
    window.location.href = link
  }
})

// 横スクロールする
new ScrollHint('.js-scrollable')

// URLパラメータがあるかどうか
function hasQueryParams(url) {
  return url.indexOf('?') !== -1
}

function scrollToElement(ele) {
  //SPのみ実行する
  if (window.matchMedia('(max-width: 767px)').matches) {
    if (hasQueryParams(window.location.href) === true) {
      $('html, body').animate({ scrollTop: $(ele).offset().top - 60 }, 400)
    }
  }
}
// エリアに適用する
if ($('.postJobInfo').length > 0) {
  scrollToElement($('.postJobInfo'))
}
